/**
 * @file Generated by js-routes 2.3.5. Based on Rails 6.1.4.1 routes of Emailrx::Application.
 * @version eb4761653067cd0be78058fc6944faa87f7eb5f03e9d48072bb9e8b4efe6ee94
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (true &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /billing/account_iframe_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_iframe_locations_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"account_iframe_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/account_iframe_usage_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_iframe_usage_history_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"account_iframe_usage_history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /highlevel_iframe/csv/account_iframed_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_iframed_locations_highlevel_iframe_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"highlevel_iframe"],[2,[7,"/"],[2,[6,"csv"],[2,[7,"/"],[2,[6,"account_iframed_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/account_s_domains_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_s_domains_list_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"account_s_domains_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accounts_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/activated_users_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activated_users_data_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"activated_users_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets/:id/add_comment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_comment_support_ticket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets/:id/add_internal_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_internal_note_support_ticket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_internal_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/erx_sheets_config_validator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_specific_erx_sheets_config_validator_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"erx_sheets_config_validator"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/performance_metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_specific_performance_metrics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"performance_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/webhook_management/agency_webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agency_webhooks_hl_app_webhook_management_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"webhook_management"],[2,[7,"/"],[2,[6,"agency_webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installed_apps/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_hl_app_installed_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installed_apps"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages_csvs/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_mailgun_messages_csvs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages_csvs"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/documentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_documentation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"documentation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/api_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"api_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/bulk_verifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/bulk_verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_bulk_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"bulk_verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cg/authenticate_iframe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_cg_authenticate_iframe_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cg"],[2,[7,"/"],[2,[6,"authenticate_iframe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cg/customizable_texts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_cg_customizable_texts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cg"],[2,[7,"/"],[2,[6,"customizable_texts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/email_verifications/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_email_verifications_verify_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"email_verifications"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cg/evaluate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_new_email_evaluation_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cg"],[2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/test_jwt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_test_jwt_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"test_jwt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /app_announcements/announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_announcements_announcement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"app_announcements"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /app_announcements/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_announcements_announcements_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"app_announcements"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/assign_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_accounts_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beehiiv_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beehiiv_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/publications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beehiiv_publication_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/publications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beehiiv_publications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/beehiiv_stats_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beehiiv_stats_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"beehiiv_stats_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/bounceban_fallback_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounceban_fallback_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"bounceban_fallback_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/bounced_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounced_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"bounced_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/bounced_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounced_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"bounced_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/bounced_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounced_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"bounced_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/bulk_initiate_certificate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_initiate_certificate_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"bulk_initiate_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/bulk_initiate_certificate_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_initiate_certificate_modal_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"bulk_initiate_certificate_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/bulk_tls_action_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_tls_action_history_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"bulk_tls_action_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/claim_ghl_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claim_ghl_app_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"claim_ghl_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id/clear(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/clicked_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clicked_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"clicked_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/clicked_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clicked_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"clicked_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/clicked_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clicked_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"clicked_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/complained_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complained_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"complained_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/complained_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complained_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"complained_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/complained_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complained_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"complained_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/webhooks/contact_event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_event_hl_app_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"contact_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/contact_validation_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_validation_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"contact_validation_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /copy_grader(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_grader_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"copy_grader"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/copygrader_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copygrader_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"copygrader_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/count_location_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_location_contacts_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"count_location_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/count_my_location_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_my_location_contacts_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"count_my_location_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/create_load_test_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_load_test_accounts_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"create_load_test_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/create_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_user_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"create_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/credits_api_web_usage_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credits_api_web_usage_data_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"credits_api_web_usage_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/credits_purchase_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credits_purchase_data_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"credits_purchase_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/widgets/custom_duration_messages_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_duration_messages_count_email_stats_unified_stats_accounts_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"custom_duration_messages_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/custom_duration_messages_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_duration_messages_count_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"custom_duration_messages_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/widgets/custom_duration_risky_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_duration_risky_domains_email_stats_unified_stats_accounts_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"custom_duration_risky_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/custom_duration_risky_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_duration_risky_domains_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"custom_duration_risky_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/custom_duration_risky_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_duration_risky_locations_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"custom_duration_risky_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/debug_custom_menu_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_custom_menu_links_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"debug_custom_menu_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/debug_custom_values_for_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_custom_values_for_location_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"debug_custom_values_for_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/delivered_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delivered_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"delivered_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/delivered_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delivered_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"delivered_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/delivered_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delivered_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"delivered_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/destroy_access_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_access_app_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"destroy_access_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/disabled_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disabled_domains_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"disabled_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/disabled_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disabled_domains_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"disabled_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/disabled_domains_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disabled_domains_widget_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"disabled_domains_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dns_lookup/lookups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dns_lookup_lookups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dns_lookup"],[2,[7,"/"],[2,[6,"lookups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/dns_lookup_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dns_lookup_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"dns_lookup_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentation_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documentation/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentation_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentation_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentation_documents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/domain_mismatch_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_mismatch_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"domain_mismatch_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/domain_mismatch_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_mismatch_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"domain_mismatch_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/domain_mismatch_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_mismatch_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"domain_mismatch_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/domain_tls_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_tls_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"domain_tls_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/domains_by_risk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domains_by_risk_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"domains_by_risk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id/domains_webhook_history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domains_webhook_history_mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"domains_webhook_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/documents/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_documentation_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /app_announcements/announcements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_app_announcements_announcement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"app_announcements"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_beehiiv_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/publications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_beehiiv_publication_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_documentation_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_documentation_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/verifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_email_verification_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/domain_requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_google_postmaster_domain_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"domain_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installed_apps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_hl_app_installed_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installed_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/edit_link_access_app_with_mailgun_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_link_access_app_with_mailgun_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"edit_link_access_app_with_mailgun_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/edit_link_iframe_app_with_mailgun_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_link_iframe_app_with_mailgun_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"edit_link_iframe_app_with_mailgun_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/edit_link_lc_access_app_with_mailgun_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_link_lc_access_app_with_mailgun_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"edit_link_lc_access_app_with_mailgun_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/edit_link_lc_mg_access_app_with_mailgun_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_link_lc_mg_access_app_with_mailgun_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"edit_link_lc_mg_access_app_with_mailgun_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/edit_linked_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_linked_accounts_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_linked_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/edit_linked_domains(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_linked_domains_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_linked_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit_list_view_preferences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_list_view_preferences_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_list_view_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mailgun_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/lc_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mailgun_lc_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"lc_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_members/:id/edit_permissions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_permissions_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_phone_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/verifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_phone_verification_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_support_ticket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_sessions/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team_sessions"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_preview/previews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_preview_preview_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_preview"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_preview/previews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_preview_previews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_preview"],[2,[7,"/"],[2,[6,"previews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_stats_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_stats_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_stats_unified_stats_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_stats_unified_stats_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bounceban_account_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_bounceban_account_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bounceban_account_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_bulk_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/ipqs_account_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_ipqs_account_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"ipqs_account_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/line_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_line_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"line_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/pricings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_pricings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"pricings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/verifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/verification_csvs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_verification_csvs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"verification_csvs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installed_apps/:id/email_volume_limits(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_volume_limits_hl_app_installed_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installed_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_volume_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/email_volume_limits_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_volume_limits_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"email_volume_limits_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/emails_sent_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_sent_data_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"emails_sent_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/verifications/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_email_verification_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization/feature_permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_permissions_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"feature_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feature_previews/:feature(.:format)
 * @param {any} feature
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_preview_path = /*#__PURE__*/ __jsr.r({"feature":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feature_previews"],[2,[7,"/"],[2,[3,"feature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/domains/:id/find_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_accounts_email_stats_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/find_ghl_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_ghl_app_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"find_ghl_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /login_as/find_user_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_user_modal_login_as_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login_as"],[2,[7,"/"],[2,[6,"find_user_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/free_from_address_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_from_address_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"free_from_address_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/free_from_address_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_from_address_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"free_from_address_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/free_from_address_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_from_address_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"free_from_address_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/webhooks/general(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const general_hl_app_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/generate_api_key(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_api_key_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_api_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/get_create_access_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_create_access_app_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"get_create_access_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/get_create_agency_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_create_agency_app_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"get_create_agency_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/get_create_iframe_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_create_iframe_app_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"get_create_iframe_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/get_create_lc_access_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_create_lc_access_app_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"get_create_lc_access_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/accounts/:id/get_publications_stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_publications_stats_beehiiv_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_publications_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/authentication/google_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_callback_google_postmaster_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"authentication"],[2,[7,"/"],[2,[6,"google_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/authentication(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_postmaster_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/domain_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_postmaster_domain_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"domain_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/domain_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_postmaster_domain_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"domain_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /highlevel_iframe/introduction(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const highlevel_iframe_introduction_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"highlevel_iframe"],[2,[7,"/"],[2,[6,"introduction"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /highlevel_iframe/root(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const highlevel_iframe_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"highlevel_iframe"],[2,[7,"/"],[2,[6,"root"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installation_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_installation_step_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installation_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installed_apps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_installed_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installed_apps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/webhook_management/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_webhook_management_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"webhook_management"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/webhook_management(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_webhook_management_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"webhook_management"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hl_app_welcome_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id/hourly_graph(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hourly_graph_mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hourly_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/lc_accounts/:id/hourly_graph(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hourly_graph_mailgun_lc_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"lc_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hourly_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiqq/jobs/hourly_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hourly_graph_sidekiqq_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sidekiqq"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"hourly_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/iframe_setup_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iframe_setup_progress_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"iframe_setup_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/iframe_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iframe_usage_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"iframe_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/bulk_verifications/:id/initiate_advance_pass(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiate_advance_pass_api_v1_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"initiate_advance_pass"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/initiate_certificate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiate_certificate_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"initiate_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/initiate_my_location_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiate_my_location_validation_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"initiate_my_location_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/initiate_subaccount_contacts_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiate_subaccount_contacts_validation_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"initiate_subaccount_contacts_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/integrated_portal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrated_portal_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"integrated_portal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/integrated_portal_enable_subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrated_portal_enable_subscription_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"integrated_portal_enable_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/internal_notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_notes_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"internal_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/performance_metrics/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jobs_admin_specific_performance_metrics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"performance_metrics"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/key_dashboard_counts_figures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const key_dashboard_counts_figures_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"key_dashboard_counts_figures"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/key_email_stats_figures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const key_email_stats_figures_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"key_email_stats_figures"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/widgets/last_month_messages_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const last_month_messages_count_email_stats_unified_stats_accounts_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"last_month_messages_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/last_month_messages_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const last_month_messages_count_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"last_month_messages_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/lazy_load_campaigns(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_campaigns_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/:id/lazy_load_campaigns(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_campaigns_mailgun_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/lazy_load_domains(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_domains_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains_locations/:id/lazy_load_domains_location(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_domains_location_mailgun_domains_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_domains_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id/lazy_load_domains(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_domains_mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/base_accounts/:id/lazy_load_domains(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_domains_mailgun_base_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"base_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/:id/lazy_load_domains(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_domains_mailgun_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/:id/lazy_load_from_addresses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_from_addresses_mailgun_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_from_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/lazy_load_location(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_location_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/:id/lazy_load_location(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_location_mailgun_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/domains/:id/lazy_load_locations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_locations_email_stats_unified_stats_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id/lazy_load_locations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_locations_mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/base_accounts/:id/lazy_load_locations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_locations_mailgun_base_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"base_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/:id/lazy_load_locations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_locations_mailgun_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/lazy_load_others(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_others_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_others"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/:id/lazy_load_others(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_others_mailgun_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_others"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/base_accounts/:id/lazy_load_sending_ips(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_sending_ips_mailgun_base_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"base_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_sending_ips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/:id/lazy_load_sending_ips(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_sending_ips_mailgun_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_sending_ips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/lazy_load_workflow_steps(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_workflow_steps_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_workflow_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/:id/lazy_load_workflow_steps(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_workflow_steps_mailgun_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_workflow_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/lazy_load_workflows(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_workflows_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/:id/lazy_load_workflows(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_workflows_mailgun_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lazy_load_workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/least_accounts_accounts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const least_accounts_accounts_data_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"least_accounts_accounts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /letter_opener
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letter_opener_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"letter_opener"]]);

/**
 * Generates rails route to
 * /letter_opener/clear(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letter_opener_web_clear_letters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /letter_opener/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letter_opener_web_delete_letter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /letter_opener/:id(/:style)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letter_opener_web_letter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"style":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"style"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /letter_opener/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const letter_opener_web_letters_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"letter_opener"]],[7,"/"]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/location_linked_lazy_load_domains(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const location_linked_lazy_load_domains_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"location_linked_lazy_load_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/webhook_management/location_webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const location_webhooks_hl_app_webhook_management_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"webhook_management"],[2,[7,"/"],[2,[6,"location_webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/locations_by_risk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locations_by_risk_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"locations_by_risk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /login_as(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_as_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login_as"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/account_sync_histories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_account_sync_histories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"account_sync_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/datatable_csvs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_datatable_csvs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"datatable_csvs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domain_sync_histories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_domain_sync_histories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domain_sync_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains_locations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_domains_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains_locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/webhooks/:id/event_mtr(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_event_mtr_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"event_mtr"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/mailgun_integration_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_integration_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"mailgun_integration_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/lc_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_lc_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"lc_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/lc_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_lc_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"lc_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/location_disablement_histories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_location_disablement_histories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"location_disablement_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages_csvs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_messages_csvs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages_csvs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/sending_ips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_sending_ip_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"sending_ips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization/mailgun_stats_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgun_stats_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"mailgun_stats_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_all_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_as_read_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_all_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/max_google_daily_send_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_google_daily_send_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"max_google_daily_send_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/max_google_daily_send_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_google_daily_send_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"max_google_daily_send_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/domains/max_google_send_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const max_google_send_line_graph_mailgun_widgets_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"max_google_send_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/mine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mine_email_verification_bulk_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[6,"mine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installed_apps/mine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mine_hl_app_installed_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installed_apps"],[2,[7,"/"],[2,[6,"mine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/lc_accounts/mine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mine_mailgun_lc_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"lc_accounts"],[2,[7,"/"],[2,[6,"mine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/mine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mine_phone_verification_bulk_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[6,"mine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/accounts/my_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_accounts_beehiiv_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"my_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/my_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_accounts_mailgun_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"my_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/my_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_location_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"my_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /app_announcements/announcements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_app_announcements_announcement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"app_announcements"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_beehiiv_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/publications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_beehiiv_publication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_documentation_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_documentation_document_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/new_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/sessions/new_email_validations_purchase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_validations_purchase_stripe_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"new_email_validations_purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/purchases/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_verification_purchase_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/verifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_verification_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/domain_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_google_postmaster_domain_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"domain_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_mailgun_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_mailgun_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/lc_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_mailgun_lc_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"lc_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_note_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_phone_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/verifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_phone_verification_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_support_ticket_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_members/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_team_member_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/new_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_users_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"new_users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installation_steps/next(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const next_hl_app_installation_steps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installation_steps"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:id/notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notes_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/opened_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opened_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"opened_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/opened_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opened_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"opened_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/opened_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opened_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"opened_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/payment_path_for_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_path_for_email_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"payment_path_for_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sidekiqq/jobs/pending_jobs_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_jobs_history_sidekiqq_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sidekiqq"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"pending_jobs_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiqq/jobs/per_day_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const per_day_graph_sidekiqq_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sidekiqq"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"per_day_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/performance_metrics_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const performance_metrics_widget_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"performance_metrics_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/permanent_failed_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permanent_failed_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"permanent_failed_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/permanent_failed_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permanent_failed_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"permanent_failed_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/permanent_failed_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permanent_failed_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"permanent_failed_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/feature_enablement/phone_validation_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phone_validation_users_admin_specific_feature_enablement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"feature_enablement"],[2,[7,"/"],[2,[6,"phone_validation_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phone_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phone_verification_bulk_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/verifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phone_verification_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phone_verification_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installation_steps/prev(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prev_hl_app_installation_steps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installation_steps"],[2,[7,"/"],[2,[6,"prev"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/preview_my_location_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_my_location_contacts_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"preview_my_location_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/email_templates/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_support_email_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_component_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_components_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/performance_metrics/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const queries_admin_specific_performance_metrics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"performance_metrics"],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_properties_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_routes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/recent_login_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recent_login_users_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"recent_login_users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/refresh_access_token_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_access_token_status_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"refresh_access_token_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/refresh_app_data_for_enabling_iframes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_app_data_for_enabling_iframes_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"refresh_app_data_for_enabling_iframes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/refresh_tls_all_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_tls_all_domains_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"refresh_tls_all_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/refresh_tls_domains_with_issues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_tls_domains_with_issues_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"refresh_tls_domains_with_issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/remove_api_key(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_api_key_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_api_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/rename_api_key(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rename_api_key_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rename_api_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/renew_certificate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renew_certificate_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"renew_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_support_ticket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/:id/request_domain_sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_domain_sync_mailgun_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_domain_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/accounts/:id/request_sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_sync_mailgun_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/performance_metrics/requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requests_admin_specific_performance_metrics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"performance_metrics"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization/reset_bulk_email_verification_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_bulk_email_verification_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"reset_bulk_email_verification_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/reset_bulk_phone_verification_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_bulk_phone_verification_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"reset_bulk_phone_verification_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/reset_email_verification_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_email_verification_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"reset_email_verification_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/reset_list_view_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_list_view_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"reset_list_view_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/reset_phone_verification_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_phone_verification_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"reset_phone_verification_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_phone_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/authentication/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_google_postmaster_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"authentication"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/widgets/risky_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risky_domains_email_stats_unified_stats_accounts_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"risky_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/risky_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risky_domains_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"risky_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/risky_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const risky_locations_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"risky_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/:id/run_advanced_catchall_pass(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_advanced_catchall_pass_email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_advanced_catchall_pass"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/schedule_deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_deactivate_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule_deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/documents/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_documentation_documents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/shards_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shards_info_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"shards_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_permission/google_postmaster/domains_teams/show_against_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_against_domain_team_permission_google_postmaster_domains_teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team_permission"],[2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"domains_teams"],[2,[7,"/"],[2,[6,"show_against_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/show_location(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_location_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/domains/:id/show_stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_stats_email_stats_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /google_postmaster/domains/:id/show_stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_stats_google_postmaster_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /mailgun/widgets/accounts/stats_hourly_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_hourly_line_graph_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"stats_hourly_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/domains/:id/stats_line_graph(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_email_stats_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/widgets/stats_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_email_stats_unified_stats_accounts_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/domains/widgets/stats_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_email_stats_unified_stats_domains_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/locations/widgets/stats_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_email_stats_unified_stats_locations_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/accounts/stats_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/domains/stats_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_mailgun_widgets_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/domains_locations/stats_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_mailgun_widgets_domains_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"domains_locations"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/locations/stats_line_graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_line_graph_mailgun_widgets_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"stats_line_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/stripe_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_callback_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"stripe_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stripe/webhooks/stripe_hook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_hook_stripe_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"stripe_hook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/email_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_email_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/email_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_email_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"email_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_ticket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_tickets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/support_tickets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_tickets_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"support_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /beehiiv/accounts/:id/sync_custom(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_custom_beehiiv_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"beehiiv"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_custom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/sync_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_status_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"sync_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/table_view_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const table_view_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"table_view_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/line_items/team_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_history_email_verification_line_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[6,"team_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_members_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team_members"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /team_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team_sessions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/tls_issues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tls_issues_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"tls_issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/toggle_api_key(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_api_key_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_api_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/toggle_contact_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_contact_validation_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"toggle_contact_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_settings/toggle_customizable_text_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_customizable_text_mode_user_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"toggle_customizable_text_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/toggle_lc_mg_configure_lc_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_lc_mg_configure_lc_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"toggle_lc_mg_configure_lc_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/toggle_lc_mg_configure_mg_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_lc_mg_configure_mg_accounts_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"toggle_lc_mg_configure_mg_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_settings/toggle_presentation_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_presentation_mode_user_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"toggle_presentation_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_settings/toggle_show_live_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_show_live_stats_user_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"toggle_show_live_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/tooltips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tooltips_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"tooltips"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/top_accounts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_accounts_data_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"top_accounts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/top_e2i_accounts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_e2i_accounts_data_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"top_e2i_accounts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_dashboard/top_email_validation_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_email_validation_users_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboard"],[2,[7,"/"],[2,[6,"top_email_validation_users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/lc_accounts/unassigned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unassigned_mailgun_lc_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"lc_accounts"],[2,[7,"/"],[2,[6,"unassigned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/unsubscribed_messages_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribed_messages_csv_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"unsubscribed_messages_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/unified_messages/unsubscribed_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribed_messages_email_stats_unified_stats_unified_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"unified_messages"],[2,[7,"/"],[2,[6,"unsubscribed_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/messages/unsubscribed_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribed_messages_mailgun_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"unsubscribed_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/campaigns/update_account_campaign_names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_account_campaign_names_mailgun_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"update_account_campaign_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/workflows/update_account_workflow_names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_account_workflow_names_mailgun_workflows_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"update_account_workflow_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_permission/google_postmaster/domains_teams/update_against_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_against_domain_team_permission_google_postmaster_domains_teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team_permission"],[2,[7,"/"],[2,[6,"google_postmaster"],[2,[7,"/"],[2,[6,"domains_teams"],[2,[7,"/"],[2,[6,"update_against_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/update_auto_recharge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_auto_recharge_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"update_auto_recharge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/beehiiv_stats_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_beehiiv_stats_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"beehiiv_stats_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/update_current_shard_number(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_current_shard_number_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"update_current_shard_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_settings/update_email_verification_provider(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_email_verification_provider_user_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"update_email_verification_provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/update_erx_stats_inclusion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_erx_stats_inclusion_mailgun_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"update_erx_stats_inclusion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization/feature_permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_feature_permissions_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"feature_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/update_iframe_config_preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_iframe_config_preference_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"update_iframe_config_preference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/update_iframed_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_iframed_locations_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"update_iframed_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/update_iframed_locations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_iframed_locations_team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_iframed_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/:id/update_ipqs_id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_ipqs_id_email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_ipqs_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/:id/update_ipqs_id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_ipqs_id_phone_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_ipqs_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/update_link_access_app_with_mailgun_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_link_access_app_with_mailgun_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"update_link_access_app_with_mailgun_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/update_link_iframe_app_with_mailgun_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_link_iframe_app_with_mailgun_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"update_link_iframe_app_with_mailgun_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/installations/update_link_lc_mg_access_app_with_mailgun_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_link_lc_mg_access_app_with_mailgun_account_hl_app_installations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"installations"],[2,[7,"/"],[2,[6,"update_link_lc_mg_access_app_with_mailgun_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/update_linked_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_linked_accounts_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_linked_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/:id/update_linked_domains(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_linked_domains_email_stats_unified_stats_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_linked_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/update_list_view_preferences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_list_view_preferences_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_list_view_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/location_sending_monitor/update_location_daily_limit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_location_daily_limit_hl_app_location_sending_monitor_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"location_sending_monitor"],[2,[7,"/"],[2,[6,"update_location_daily_limit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/location_sending_monitor/update_location_monitoring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_location_monitoring_hl_app_location_sending_monitor_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"location_sending_monitor"],[2,[7,"/"],[2,[6,"update_location_monitoring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization/mailgun_stats_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_mailgun_stats_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"mailgun_stats_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team_members/:id/update_permissions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_permissions_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/location_sending_monitor/update_replacement_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_replacement_domain_hl_app_location_sending_monitor_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"location_sending_monitor"],[2,[7,"/"],[2,[6,"update_replacement_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/:id/update_selected_csv_column(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_selected_csv_column_email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_selected_csv_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/:id/update_selected_csv_column(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_selected_csv_column_phone_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_selected_csv_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/tickets/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_support_ticket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_verification/bulk_verifications/:id/update_time_estimate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_time_estimate_email_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_time_estimate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /phone_verification/bulk_verifications/:id/update_time_estimate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_time_estimate_phone_verification_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phone_verification"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_time_estimate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/update_tls_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_tls_status_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"update_tls_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/update_token_setting_for_highlevel_locations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_token_setting_for_highlevel_locations_team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_token_setting_for_highlevel_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization/tooltips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_tooltips_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"tooltips"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customization/validation_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_validation_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"validation_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/csvs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_csvs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"csvs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_all_except_p2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_all_except_p2_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_all_except_p2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_all_tables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_all_tables_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_all_tables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_p2_shards_only(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_p2_shards_only_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_p2_shards_only"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_default(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_default_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_default_email_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_default_email_events_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_default_email_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_default_email_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_default_email_messages_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_default_email_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_default_saved_message_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_default_saved_message_stats_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_default_saved_message_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_1_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_1"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_2_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_36(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_36_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_36"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_37(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_37_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_37"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_38(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_38_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_38"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_39(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_39_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_39"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_3_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_3"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_40(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_40_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_40"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_4(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_4_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_4"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partition_5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partition_5_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partition_5"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_11_to_15(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_11_to_15_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_11_to_15"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_16_to_20(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_16_to_20_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_16_to_20"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_1_to_5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_1_to_5_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_1_to_5"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_21_to_25(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_21_to_25_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_21_to_25"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_26_to_30(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_26_to_30_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_26_to_30"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_31_to_35(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_31_to_35_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_31_to_35"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_36_to_40(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_36_to_40_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_36_to_40"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_primary_db_partitions_6_to_10(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_primary_db_partitions_6_to_10_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_primary_db_partitions_6_to_10"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_shard_1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_shard_1_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_shard_1"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_shard_2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_shard_2_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_shard_2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_shard_3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_shard_3_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_shard_3"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_shard_4(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_shard_4_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_shard_4"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_shard_5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_shard_5_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_shard_5"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/admin_insights/vacuum_shard_6(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vacuum_shard_6_admin_specific_admin_insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"admin_insights"],[2,[7,"/"],[2,[6,"vacuum_shard_6"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_specific/erx_sheets_config_validator/validate_pasted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_pasted_admin_specific_erx_sheets_config_validator_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_specific"],[2,[7,"/"],[2,[6,"erx_sheets_config_validator"],[2,[7,"/"],[2,[6,"validate_pasted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customization/validation_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validation_columns_customization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customization"],[2,[7,"/"],[2,[6,"validation_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hl_app/contact_verifications/validations_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validations_history_hl_app_contact_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hl_app"],[2,[7,"/"],[2,[6,"contact_verifications"],[2,[7,"/"],[2,[6,"validations_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/domains/tls/verify_dns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_dns_mailgun_domains_tls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tls"],[2,[7,"/"],[2,[6,"verify_dns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/view_erx_stats_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_erx_stats_locations_mailgun_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"view_erx_stats_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/locations/view_locations_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_locations_list_mailgun_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"view_locations_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentation/documents/:id/view_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_pdf_documentation_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /view_preferences/customized_texts/:key
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_preferences_customized_text_path = /*#__PURE__*/ __jsr.r({"key":{"r":true}}, [2,[7,"/"],[2,[6,"view_preferences"],[2,[7,"/"],[2,[6,"customized_texts"],[2,[7,"/"],[3,"key"]]]]]]);

/**
 * Generates rails route to
 * /view_preferences/customized_texts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_preferences_customized_texts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"view_preferences"],[2,[7,"/"],[2,[6,"customized_texts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_stats/unified_stats/accounts/widgets/vital_signs_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vital_signs_details_email_stats_unified_stats_accounts_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_stats"],[2,[7,"/"],[2,[6,"unified_stats"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"vital_signs_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/vital_signs_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vital_signs_details_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"vital_signs_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailgun/widgets/webhook_errors_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_errors_domains_mailgun_widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"webhook_errors_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

